import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SelectedCategory from '../appcomponents/SelectedCategory';
import LineaFarmaceutica from '../assets/imagenes/LineaFaramaceutica.png';
import LineaVeterinaria from '../assets/imagenes/LineaVeterinaria.png';
import NutricionAnimal from '../assets/imagenes/NutricionVeterinaria.png';
import HerbalesNutraceutica from '../assets/imagenes/HerbalesNutraceutica.png';
import AlimentacionHumana from '../assets/imagenes/AlimentacionHumana.jpg';
import '../styles/Productos/Products.css';

import KeyboardDoubleArrowLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';

import { useTranslation } from 'react-i18next';

function Products() {
  const [selectedCategory, setSelectedCategory] = useState(null);

    const [categoryImage, setCategoryImage] = useState(null);
    const handleClick = (category) => {
        setSelectedCategory(category);
        // Set image depending on category
        switch (category) {
            case 'Línea Farmacéutica':
                setCategoryImage(LineaFarmaceutica);
                break;
            case 'Línea Veterinaria':
                setCategoryImage(LineaVeterinaria);
                break;
            case 'Nutrición Animal':
                setCategoryImage(NutricionAnimal);
                break;
            case 'Herbales y Nutracéutica':
                setCategoryImage(HerbalesNutraceutica);
                break;
            case 'Alimentación Humana':
                setCategoryImage(AlimentacionHumana);
                break;
            default:
                setCategoryImage(null);
        }
    };
  
    const handleBackClick = () => {
        setSelectedCategory(null);
        setCategoryImage(null);
    };

  const {t} = useTranslation();

return (
    <section>
        <div className="title-container">
            <div className="txt-title">
                <h2>{t("products_u")}</h2>
            </div>
        </div>
        {selectedCategory === null && (
            <>
                <div className="category-description">
                    <h3 style={{color:'#00504E', fontFamily:'Outfit, sans-serif;', fontWeight: '700'}}>{t("categories")}</h3>
                    <p style={{fontFamily: 'Roboto, sans-serif', fontWeight: '400'}}>{t("categories_1")}</p>
                </div>
            </>
        )}
        <div className="products-container">
            {selectedCategory === null && (
                <>
                    <div className="product" onClick={() => handleClick('Línea Farmacéutica')}>
                        <img src={LineaFarmaceutica} alt="LineaFarmaceutica" className="product-img" />
                        <h3>{t("pharma_l")}</h3>
                    </div>
                    <div className="product" onClick={() => handleClick('Línea Veterinaria')}>
                        <img src={LineaVeterinaria} alt="LineaVeterinaria" className="product-img" />
                        <h3>{t("vet_l")}</h3>
                    </div>
                    <div className="product" onClick={() => handleClick('Nutrición Animal')}>
                        <img src={NutricionAnimal} alt="NutricionAnimal" className="product-img" />
                        <h3>{t("nutrients")}</h3>
                    </div>
                    <div className="product" onClick={() => handleClick('Herbales y Nutracéutica')}>
                        <img src={HerbalesNutraceutica} alt="HerbalesNutraceutica" className="product-img" />
                        <h3>{t("herbs")}</h3>
                    </div>
                    <div className="product" onClick={() => handleClick('Alimentación Humana')}>
                        <img src={AlimentacionHumana} alt="AlimentacionHumana" className="product-img" />
                        <h3>{t("food")}</h3>
                    </div>
                </>
            )}
            {/* Render products based on the selected category */}
            {selectedCategory && (
                <div className='category-container'>
                    <Link className="volver" onClick={handleBackClick}> <KeyboardDoubleArrowLeft style={{fontSize:'30px'}}/>{t("back")}</Link>
                    <SelectedCategory category={selectedCategory} image={categoryImage} />
                </div>
            )}
        </div>
    </section>
);
}

export default Products;
